import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4d732186&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d732186",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d732186')) {
      api.createRecord('4d732186', component.options)
    } else {
      api.reload('4d732186', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4d732186&scoped=true", function () {
      api.rerender('4d732186', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/pointsMall/index.vue"
export default component.exports